import { render, staticRenderFns } from "./BrandCreate.vue?vue&type=template&id=2826c000&scoped=true&"
import script from "./BrandCreate.vue?vue&type=script&lang=js&"
export * from "./BrandCreate.vue?vue&type=script&lang=js&"
import style0 from "./BrandCreate.vue?vue&type=style&index=0&id=2826c000&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2826c000",
  null
  
)

export default component.exports